export const DEFAULT_SEND_MESSAGE_PLACEHOLDER = 'Ask me anything ...'
